import { ICapsuleData } from "@sg/components/CapsuleBar/type.d";

export const getMetricBoardRatioTextAndValue = ({unit, value}: { unit: string; value: string; }) => {
  const arr: any[] = [];
  const unitArr = unit?.split(',') || [];
  const ratioArr = value?.split(',') || [];
  for (let i = 0;i < unitArr.length;i++) {
    // Format percentage to maximum 2 decimal places
    let formattedValue = ratioArr[i];
    if (formattedValue && !formattedValue.toString().trim().endsWith('%')) {
      // Parse the number and format to maximum 2 decimal places
      const numValue = parseFloat(formattedValue);
      if (!isNaN(numValue)) {
        // Use toFixed(2) then remove trailing zeros
        formattedValue = `${numValue.toFixed(2).replace(/\.?0+$/, '')}%`;
      } else {
        formattedValue = `${formattedValue}%`;
      }
    }
    arr.push({ value: unitArr[i], text: formattedValue });
  }
  return arr;
};

export const getTableCapsuleConfig = ({ template, value, maxValue }: { template?: ICapsuleData[]; value: number; maxValue: number; }): ICapsuleData[] => {
  const defaultTemplate: ICapsuleData[] = [
    { title: 'showValue', value: 0, rate: 0, type: 'pillar', displayTitleFormat: 'formattedValue', colorType: 'red', titlePosition: 'outside' },
    { title: 'maxValue', value: 0, rate: 0, type: 'total', displayTitleFormat: 'formattedValue', colorType: 'gray', isHide: true },
  ];
  const newArr: ICapsuleData[] = [];
  (template || defaultTemplate).forEach(item => {
    switch (item.title) {
      case 'showValue':
        newArr.push({
          ...item,
          value,
          rate: Math.abs(value) / Math.abs(maxValue) * 100,
          colorType: value > 0 ? 'green' : 'red',
        });
        break;
      case 'maxValue':
        // 这个是为了获取最大值
        newArr.push({
          ...item,
          value: value > 0 ? maxValue : -maxValue,
        });
        break;
      default:
        newArr.push(item);
        break;
    }
  });
  return newArr;
};